import {LineupPlayerToDownloadStructure, AbstractOptimizedLineupsView} from './optimized-lineups-view';

export class DraftkingsOptimizedLineupsView extends AbstractOptimizedLineupsView {
    protected getPlayerCellView(player: LineupPlayerToDownloadStructure): string {
        return `${this.adjustPlayerName(player.name)} (${player.id})`;
    }
}
